import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getCurrentGoldPrice } from "../../services/gold-price";
import { getSystemContents } from "../../services/statistics";
import { getCommoditiesList } from "../../services/commodities";
import ChartModal from "../ChartModal";

export default function PriceBox() {
  const [goldPrice, setGoldPrices] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");
  const [priceBoxTitle, setPriceBoxTitle] = useState("");
  useEffect(() => {
    function fetchData() {
      getSystemContents().then((res) => {
        if (res.status == 200) {
          let data = res?.data?.results;
          for (let item of data) {
            if (item.key === "price_box") {
              setPriceBoxTitle(item.value);
            }
          }
        }
      });
      getCommoditiesList().then((d) => {
        const result = [];
        const commodities = d?.data?.results;
        for (let c of commodities) {
          getCurrentGoldPrice(c.id).then((res) => {
            const data = res?.data?.data;
            if (res.status == 200) {
              result.push({
                color: c.ui_data.colors.primary,
                icon: c.ui_data.icons.primary,
                name: c.name,
                price: data,
              });
              if (result.length === commodities.length) {
                setGoldPrices(result);
              }
            }
          });
        }
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (activeMenu === "buy") {
      setModalIsOpen(true);
    }
    if (activeMenu === "sell") {
      setModalIsOpen(true);
    }
  }, [activeMenu]);
  return (
    <div className="price-box-dashboard">
      <div className="col-12 mt-4 p-3">
        <div className="text-center">
          <h3>{priceBoxTitle}</h3>
        </div>

        <div className="row pt-2">
          {goldPrice.map((el) => (
            <div className="price-row-new">
              <div className="price-box-commodity-icon">
                <img src={el.icon} />
              </div>
              <div
                className="price-box-commodity-name"
                style={{ color: el.color }}
              >
                {el.name}
              </div>
              <div
                className="price-box-commodity-price"
                style={{ color: el.color }}
              >
                {!isNaN(el.price?.sell_price?.soot) ? (
                  <>
                    {new Intl.NumberFormat("fa", {
                      maximumFractionDigits: 4,
                    }).format(el.price?.sell_price?.gram)}
                    {" تومان"}
                  </>
                ) : (
                  "در حال بارگزاری"
                )}
              </div>
              <div className="visible-xs price-box-commodity-chart">
                <img src={"/images/chart.svg"} />
              </div>
              <div
                className={
                  el.price?.sell_price?.variation_percent > 0
                    ? "bottom-row-price-box-value price-box-commodity-variation text-success"
                    : "bottom-row-price-box-value price-box-commodity-variation text-danger"
                }
              >
                {!isNaN(el?.price?.sell_price?.soot) ? (
                  <>
                    {"%"}
                    {new Intl.NumberFormat("fa", {
                      maximumFractionDigits: 4,
                    }).format(el?.price?.sell_price?.variation_percent)}{" "}
                  </>
                ) : (
                  "در حال بارگزاری"
                )}
              </div>
            </div>
          ))}
          <div
            className="price-box-shadow-text visible-xs"
            onClick={() => setModalIsOpen(true)}
          >
            نمایش نمودار
          </div>
        </div>
      </div>
      <ChartModal
        modalIsOpen={modalIsOpen}
        Openchanger={(status) => setModalIsOpen(status)}
      />
    </div>
  );
}
